import React from "react";
import { EVENTS } from "../lib/siteData";

export default function Events() {
  return (
    <section
      id="events"
      data-testid="events-section"
      className="py-20 sm:py-28 bg-ivorySoft border-y border-ink-10"
      style={{ borderColor: "rgba(11,31,56,0.12)" }}
    >
      <div className="container-prose">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
          <div className="lg:col-span-6">
            <p className="overline">12 — Speaking & Recognition</p>
            <h2 className="h2-display mt-4 text-4xl sm:text-5xl text-ink">
              A career on <span className="italic text-forest">stage</span> and in the field.
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="body-prose text-base sm:text-lg text-ink/70 max-w-lg">
              Selected forums, institutions and partnerships across India and abroad.
            </p>
          </div>
        </div>

        <div className="relative pl-6 sm:pl-10">
          <div
            aria-hidden
            className="absolute left-1.5 sm:left-3 top-2 bottom-2 w-px"
            style={{ background: "rgba(11,31,56,0.25)" }}
          />
          <ul className="space-y-10 sm:space-y-12">
            {EVENTS.map((e, i) => (
              <li
                key={i}
                data-testid={`event-${i}`}
                className="relative grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-8"
              >
                <span
                  aria-hidden
                  className="absolute -left-[26px] sm:-left-[42px] top-2 inline-block h-2.5 w-2.5 rounded-full bg-forest ring-4 ring-ivorySoft"
                />
                <div className="sm:col-span-3">
                  <p className="text-[12px] uppercase tracking-[0.22em] text-forest font-medium">
                    {e.date}
                  </p>
                </div>
                <div className="sm:col-span-9">
                  <h3
                    className="text-2xl sm:text-3xl text-ink"
                    style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
                  >
                    {e.title}
                  </h3>
                  <p className="mt-2 body-prose text-base text-ink/70 max-w-2xl">
                    {e.detail}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
